import { getCoreRowModel, useReactTable } from "@tanstack/react-table";
import { useTranslate } from "@tolgee/react";
import { useHyperFills } from "#/hooks/use-hyperliquid-account";
import { DataTable } from "./data-table";
import { recentTradesColumns } from "./recent-trades-columns";

const coreRowModel = getCoreRowModel();

export function RecentTradesTable() {
	const { t } = useTranslate();
	const { fills, isPending, isFetching, isFetched, isError, refetch } =
		useHyperFills();

	const table = useReactTable({
		data: fills,
		columns: recentTradesColumns,
		getCoreRowModel: coreRowModel,
	});

	return (
		<div className="min-w-0">
			<h2 className="mb-4 text-body2-bold text-foreground">
				{t("portfolio.recent-trades")}
			</h2>
			<DataTable
				table={table}
				emptyMessage={t("portfolio.no-trades")}
				isLoading={!isFetched && (isPending || isFetching)}
				loadingMessage={t("state.loading-wallet")}
				heightClassName="h-80"
				contentClassName="min-w-[680px]"
				isError={isError}
				onRetry={() => {
					refetch();
				}}
			/>
		</div>
	);
}
